import { render } from "./ShowInfoVA.vue?vue&type=template&id=32d91740&scoped=true"
import script from "./ShowInfoVA.vue?vue&type=script&lang=js"
export * from "./ShowInfoVA.vue?vue&type=script&lang=js"

import "./ShowInfoVA.vue?vue&type=style&index=0&id=32d91740&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d91740"]])

export default __exports__